import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type ForgotPasswordOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  email: string;
};

export const forgotPassword = async <TFunctions>(
  options: ForgotPasswordOptions<TFunctions>,
): Promise<void> => {
  const { functions, httpsCallable, email } = options;
  const callable = httpsCallable<{ email: string }, void>(
    functions,
    'auth0Migration-resetPassword',
  );

  await callable({ email });
};
